import { render, staticRenderFns } from "./StepConfirm.vue?vue&type=template&id=b1f7d71c"
import script from "./StepConfirm.vue?vue&type=script&lang=js"
export * from "./StepConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports